import Util from '../common/Util.js';
import AbsSection from './AbsSection';

export default class SecAttack extends AbsSection {
    constructor(_container='', _dataM={}, _option={}){
        super(_container, _dataM, _option, 'attack');

        if( this.isShow ) {
            $(_container + ' .title-link').prepend(_option.title);
        }
    }

    setTemplate(){
        let data = this.dataM.option.attackArea.attackData;

        let tpl = data.map( (item) => {
            return `
        <li class="item">
            <a href="attack/list?tv=${Util.getParamByName('tv')}&query=${encodeURIComponent(item.query)}&banner=${encodeURIComponent(item.banner)}" class="item-link">
                <div class="item-inner">
                    <div class="thumb-img" style="background-image: url(${item.image});"></div> 
                    <div class="text-area">
                        <div class="text-inner">
                            <span class="text">${item.title}</span>
                            ${item.subtitle ? `<span class="subtext">${item.subtitle}</span>` : ``}
                        </div>
                    </div>
                </div>
            </a>
        </li>`;
        }).join('');

        $('.main-attack-list', this.container).append(tpl);
    }


} // end of class
